import React from "react";
import { FaRegCheckCircle } from "react-icons/fa";
const PaymentSuccess = () => {
  return (
    <>
      <div className="container-fluid pt-5">
        <div className="container">
          <div className="text-center">
            <span>
              <FaRegCheckCircle className="icon-style-msg mb-3" size="10rem" />
            </span>
            <h1 className="banner-title font-trajan coming-soon-title mb-5">
              Thank you for your purchase!
            </h1>
          </div>
        </div>
      </div>
    </>
  );
};

export default PaymentSuccess;
